import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { SavedAddressComponent } from '../saved-address/saved-address.component';
import { VendorService } from '../../vendor-portal/vendor.service';
import { QuickDialog } from '../../utilities/Dialog/QuickDialog';

@Component({
  selector: 'app-view-saved-address',
  templateUrl: './view-saved-address.component.html',
  styleUrls: ['./view-saved-address.component.css']
})
export class ViewSavedAddressComponent implements OnInit {


  customer;
  addresses = [];
  constructor(private dialog:MatDialog, public dialogRef: MatDialogRef<SavedAddressComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private vendor: VendorService) {
    this.customer = data;
  }


  close() {
    this.dialogRef.close();
  }

  remove(address){
    new QuickDialog(this.dialog).
      DecisionDialog({
        message: `Are you sure you want to remove ${address.address}`,
        options: [
          {
            code: 'yes',
            message: "Yes, Remove Address",
            icon: 'fa-thumbs-up'
          },
          {
            code: 'no',
            message: 'No, cancel',
            icon: 'fa-ban'
          }
        ]
      }).then(async (choice) => {
        if (choice == 'yes') {
          this.vendor.removeSavedAddress(address.id).then((res) => {
            this.load();
          }).catch(e => {
            new QuickDialog(this.dialog).InfoDialog("We were unable to delete the record please try again", "We're Sorry", "OK");
          })
        }
      });
  }

  add(){
    this.dialogRef.close('add');
  }


  load(){
    this.vendor.getSavedAddress(this.customer.savedid).then((res) => {
      this.addresses = res;
    })
  }
  ngOnInit() {
    this.load();
  }

}



// WEBPACK FOOTER //
// ./src/app/admin-dashboard/view-saved-address/view-saved-address.component.ts